import Cookies from 'js-cookie';
import LZUTF8 from 'lzutf8';
import uuid from 'uuid/v4';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { watchForDatabaseChanges } from '../helpers/Firebase/database';
const CRYPTO_SECRET = process.env.GATSBY_CRYPTO_SECRET;
var CryptoJS = require('crypto-js');

export function getEnv() {
  if (process.env.GATSBY_FIREBASE_PROJECT_ID === 'pronto-pay-api') {
    return 'production';
  } else {
    return 'development';
  }
}

export function listenForAppUpdates() {
  watchForDatabaseChanges(`/config/build_version`, (live_version) => {
    const env = getEnv();
    console.log('COMMIT_HASH', process.env.GATSBY_COMMIT_HASH);

    if (env === 'production' && live_version && (process.env.GATSBY_COMMIT_HASH !== live_version)) {
      console.log(`api version ${process.env.GATSBY_COMMIT_HASH} out of date, force reloading`);

      if (typeof (window) !== 'undefined') {
        window.location.reload(true);
      }
    }
  });
}

export function getCurrentPage(pathname) {
  if (typeof window !== 'undefined') {
    if (pathname) {
      return window.location.pathname || '';
    } else {
      return window.location.href || '';
    }
  }
  return '';
}

export function getPageHash() {
  if (typeof window !== 'undefined') {
    return window.location.hash.split('#')[1];
  }
  return '';
}
export function setCaretPosition(element, pos) {
  if (element.setSelectionRange) {
    element.focus();
    element.setSelectionRange(pos, pos);
  } else if (element.createTextRange) {
    var range = element.createTextRange();
    range.collapse(true);
    range.moveEnd('character', pos);
    range.moveStart('character', pos);
    range.select();
  }
}

export function sortByDate(a, b) {
  if (a.date === b.date) {
    return 0;
  } else if (a.date > b.date) {
    return -1;
  } else if (a.date < b.date) {
    return 1;
  }
}

export function sortByAmount(a, b) {
  const amountA = a.amount * 100;
  const amountB = b.amount * 100;

  if (amountA === amountB) {
    return 0;
  } else if (amountA > amountB) {
    return -1;
  } else if (amountA < amountB) {
    return 1;
  }
}

export function sortByAmountReverse(a, b) {
  const amountA = a.amount * 100;
  const amountB = b.amount * 100;

  if (amountA === amountB) {
    return 0;
  } else if (amountA > amountB) {
    return 1;
  } else if (amountA < amountB) {
    return -1;
  }
}

export function sortByDateReverse(a, b) {
  if (a.date === b.date) {
    return 0;
  } else if (a.date > b.date) {
    return 1;
  } else if (a.date < b.date) {
    return -1;
  }
}

export function chooseRandomFromArray(myArray) {
  return myArray[Math.floor(Math.random() * myArray.length)];
}

export function compressString(str) {
  return LZUTF8.compress(str);
}

export function encryptWithSecret(value) {
  return CryptoJS.AES.encrypt(value, CRYPTO_SECRET).toString();
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      return resolve(reader.result);
    };
    reader.onerror = function (error) {
      return reject(error);
    };
  });
}

function backspaceListener(event) {
  window.GLOBAL_BACKSPACE = event.keyCode === 8;
}

function updateBackspaceForInput() {
  const currentElement = document.activeElement;

  if (currentElement.tagName.toLowerCase() === 'input') {
    currentElement.addEventListener('keydown', backspaceListener);
  }
}
export function updateNumberInput(phoneNumber = '') {
  updateBackspaceForInput();
  const replace3 = str => str.replace(/(\d{3})/, '$1-');
  const replace7 = str => str.replace(/(\d{3})(\d{3})/, '$1-$2-');

  if (window.GLOBAL_BACKSPACE) {
    if (
      /\D/gi.test(phoneNumber[phoneNumber.length - 1]) ||
      phoneNumber.length === 3 ||
      phoneNumber.length === 6
    ) {
      //last char is not a digit
      return phoneNumber.slice(0, -1);
    } else {
      return phoneNumber;
    }
  }
  phoneNumber = phoneNumber.replace('/', ' ').replace(/\D+/g, '');

  if (phoneNumber[0] == 1) {
    phoneNumber = phoneNumber.slice(1);
  }

  let phoneNumber2 = phoneNumber.substr(0, 10);

  if (phoneNumber2.length >= 7) {
    return replace7(phoneNumber2);
  } else if (phoneNumber2.length >= 3) {
    return replace3(phoneNumber2);
  } else {
    return phoneNumber;
  }
}

export function updateEINNumber(ein = '') {
  updateBackspaceForInput();
  ein = ein.replace(/\D+/g, '');
  const replace2 = str => str.replace(/(\d{2})/, '$1-');
  const replace9 = str => str.replace(/(\d{2})(\d{7})/, '$1-$2');

  if (ein.length >= 9) {
    return replace9(ein.substr(0, 9));
  } else if (ein.length >= 2) {
    ein = replace2(ein);
  }

  if (window.GLOBAL_BACKSPACE) {
    if (ein.length === 3) {
      //last char is not a digit
      ein = ein.slice(0, -1);
    }
  }
  return ein;
}

export function updateCCInput(cc = '') {
  updateBackspaceForInput();
  cc = cc.replace(/\D+/g, '');
  const replace4 = str => str.replace(/(\d{4})/, '$1-');
  const replace8 = str => str.replace(/(\d{4})(\d{4})/, '$1-$2-');
  const replace12 = str => str.replace(/(\d{4})(\d{4})(\d{4})/, '$1-$2-$3-');
  const replace16 = str =>
    str.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1-$2-$3-$4');

  if (cc.length >= 16) {
    return replace16(cc.substr(0, 16));
  } else if (cc.length >= 12) {
    cc = replace12(cc);
  } else if (cc.length >= 8) {
    cc = replace8(cc);
  } else if (cc.length >= 4) {
    cc = replace4(cc);
  }

  if (window.GLOBAL_BACKSPACE) {
    if (cc.length === 5 || cc.length === 10 || cc.length === 15) {
      //last char is not a digit
      cc = cc.slice(0, -1);
    }
  }
  return cc;
}

export function updateBirthdateInput(birthdate) {
  updateBackspaceForInput();
  birthdate = birthdate.replace(/[^0-9|(/)]/g, '');
  const replace2 = str => str.replace(/(\d{2})/, '$1/');
  const replace5 = str => str.replace(/(\d{2})(\d{2})/, '$1/$2/');

  if (window.GLOBAL_BACKSPACE) {
    if (
      /\D/gi.test(birthdate[birthdate.length - 1]) ||
      birthdate.length === 3 ||
      birthdate.length === 6
    ) {
      //last char is not a digit
      return birthdate.slice(0, -1);
    } else {
      return birthdate;
    }
  }

  let birthdate2 = birthdate
    .replace('/', ' ')
    .replace(/\D+/g, '')
    .substr(0, 8);

  if (birthdate2.length >= 5) {
    return replace5(birthdate2);
  } else if (birthdate2.length >= 2) {
    return replace2(birthdate2);
  } else {
    return birthdate;
  }
}

export function formatAmount(amount) {
  amount = amount + '';
  return parseInt(amount.replace('$', '').replace(/[^0-9]/g, ''));
}

export function getSavePercentage(price, sale_price) {
  const percent = Math.round(((price - sale_price) / price) * 100);
  return `${percent}%`;
}

export function formatDollarAmount(value = 0, commas = true) {
  let formattedValue = parseFloat(formatAmount(value) / 100).toFixed(2);

  if (formattedValue >= 1000000) {
    formattedValue = '1000000.00';
  }

  if (commas) {
    formattedValue = numberWithCommas(formattedValue);
  }
  return formattedValue;
}

export function numberWithCommas(x = '') {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function setCookie(key, value, expires = 14) {
  const options = {};

  if (expires) {
    options.expires = expires;
  }

  if (value) {
    Cookies.set(key, value, options);
  } else {
    Cookies.remove(key);
  }
}

export function getCookie(key) {
  return Cookies.get(key);
}

export function disableBackgroundScrolling(val) {
  // var freezeVp = function (e) {
  //   e.preventDefault();
  // };
  // if (val === true) {
  //   document.body.addEventListener('touchmove', freezeVp, false);
  // } else {
  //   document.body.removeEventListener('touchmove', freezeVp, false);
  // }
}

export function downloadCSV(data, labels, fileName) {
  const dataCopy = [...data];
  const dataFormatted = dataCopy.map(({
    date, __id, ...other
  }) => ({
    month: moment(parseInt(date)).format('MM'),
    year: moment(parseInt(date)).format('YYYY'),
    day: moment(parseInt(date)).format('DD'),
    id: __id,
    ...other,
  }));
  const csv = makeCSVString(labels, dataFormatted);
  var blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
  saveAs(blob, `${fileName} ${moment().format('MM/DD/YYYY')}.csv`);
}

export function makeCSVString(labels, data) {
  const labelString = labels.map(label => label.toUpperCase()).join(',');
  let csvString = labelString + '\n';

  data.forEach(column => {
    let columnArray = [];

    labels.forEach(label => {
      let value;

      if (column[label]) {
        value = column[label].toString();
        value = value.replace(/(.*,.*)/gi, '"$1"');
      }
      value = value || ' ';
      columnArray.push(value);
    });
    csvString += columnArray.join(',') + '\n';
  });
  return csvString;
}

export function checkForNull(vals) {
  let nullValues = false;

  Object.keys(vals).forEach(key => {
    nullValues = typeof vals[key] === 'undefined' || nullValues;
  });
  return nullValues;
}

/*  removeStorage: removes a key from localStorage and its sibling expiracy key
    params:
        key <string>     : localStorage key to remove
    returns:
        <boolean> : telling if operation succeeded
 */
export function removeStorage(name) {
  try {
    localStorage.removeItem(name);
    localStorage.removeItem(name + '_expiresIn');
  } catch (e) {
    console.log(
      'removeStorage: Error removing key [' +
      name +
      '] from localStorage: ' +
      JSON.stringify(e)
    );
    return false;
  }
  return true;
}
/*  getStorage: retrieves a key from localStorage previously set with setStorage().
  params:
      key <string> : localStorage key
  returns:
      <string> : value of localStorage key
      null : in case of expired key or failure
*/
export function getStorage(key) {
  var now = Date.now(); //epoch time, lets deal only with integer
  // set expiration for storage
  var expiresIn = localStorage.getItem(key + '_expiresIn');

  if (!expiresIn) {
    expiresIn = 0;
  }

  if (expiresIn < now) {
    // Expired
    removeStorage(key);
    return null;
  } else {
    try {
      var value = localStorage.getItem(key);

      try {
        value = JSON.parse(value);
      } catch {
        //
      }
      return value;
    } catch (e) {
      console.log(
        'getStorage: Error reading key [' +
        key +
        '] from localStorage: ' +
        JSON.stringify(e)
      );
      return null;
    }
  }
}
/*  setStorage: writes a key into localStorage setting a expire time
  params:
      key <string>     : localStorage key
      value <string>   : localStorage value
      expires <number> : number of seconds from now to expire the key
  returns:
      <boolean> : telling if operation succeeded
*/
export function setStorage(key, value, expires) {
  if (!expires) {
    expires = 24 * 60 * 60; // default: seconds for 1 day
  } else {
    expires = Math.abs(expires); //make sure it's positive
  }

  var now = Date.now(); //millisecs since epoch time, lets deal only with integer
  var schedule = now + expires * 1000;

  try {
    localStorage.setItem(key, value);
    localStorage.setItem(key + '_expiresIn', schedule);
  } catch (e) {
    console.log(
      'setStorage: Error setting key [' +
      key +
      '] in localStorage: ' +
      JSON.stringify(e)
    );
    return false;
  }
  return true;
}

export function getLast4(cardNumber) {
  cardNumber = cardNumber || '';
  return cardNumber.substr(cardNumber.length - 4, cardNumber.length);
}

export function getUUID(val = 12) {
  return uuid()
    .replace(/[a-zA-Z]+|(-)/gi, '')
    .substr(0, val);
}

export function clearAllTimeouts() {
  var id = window.setTimeout(function () { }, 0);

  while (id-- && typeof window !== 'undefined') {
    window.clearTimeout(id); // will do nothing if no timeout with id is present
  }
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function absoluteCenterStyle() {
  return {
    transform: 'translate(-50%, -50%)',
    top: '50%',
    left: '50%',
    position: 'absolute',
  };
}
